(function iife(w, d) {
  'use strict';

  if (typeof window.IntersectionObserver === 'undefined') {
    return;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var lazyVideos = Array.prototype.slice.call(document.querySelectorAll('video.js-lazy-video'));

    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];

            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove('js-lazy-video');
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  });
})(window, document);
